module.exports = __webpack_public_path__ + "img/0-22.7b2e36eb.gif";